export const EMPTY = 'empty';
export const NOT_EMPTY = 'not_empty';
export const EQUALS = '=';
export const NOT_EQUALS = '<>';
export const AND = 'AND';
export const OR = 'OR';
export const LESS_THAN = '<';
export const GREATER_THAN = '>';
export const BETWEEN = 'between';
export const WITHIN = 'within';
